module.exports = __webpack_public_path__ + "img/[好的].792f871b.svg";